'use client';

import { GTM_NOTSET_INTEGER, GTM_NOTSET_STRING, getGtmAttr } from '@musinsa/frontend-utils';
import { Button, Typography } from '@musinsa/mds';
import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import type { SearchProductService } from '@musinsa/services-curator';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';
import { SearchedProduct } from '../../product/components/variants/SearchedProduct';
import { LinkGenerationBottomSheet } from './LinkGenerationBottomSheet';

interface Props {
  item: SearchProductService;
  className?: string;
  index?: number;
  callbackClickProduct?: (item: SearchProductService) => void;
  callbackImpression?: (item: SearchProductService) => void;
  onClickLikeButton?: (item: SearchProductService, nextIsLiked: boolean) => void;
  callbackClickGenerateLink: () => void;
}

const ProductSearchItemComponent = ({
  item,
  className,
  index,
  callbackClickProduct,
  callbackImpression,
  onClickLikeButton,
  callbackClickGenerateLink,
}: Props) => {
  const { service } = useDeviceInfo();
  const { className: gtmClassName, ...gtmDataAttrs } =
    service === SERVICE.MUSINSA
      ? getGtmAttr(['select_item', 'view_item_list'], {
          discount:
            item.originalPrice != null && item.price != null
              ? item.originalPrice - item.price
              : GTM_NOTSET_INTEGER,
          discount_rate: item.salesRate?.toString() ?? GTM_NOTSET_STRING,
          item_brand: item.brandName ?? GTM_NOTSET_STRING,
          item_category: GTM_NOTSET_STRING,
          item_id: String(item.goodsNo),
          item_list_id: GTM_NOTSET_STRING,
          item_list_index: index?.toString() ?? GTM_NOTSET_STRING,
          original_price: item.originalPrice ?? GTM_NOTSET_INTEGER,
          price: item.price ?? GTM_NOTSET_INTEGER,
          quantity: 1,
          ...(item.couponPrice != null ? { best_price: item.couponPrice } : {}),
        })
      : { className: undefined };

  return (
    <div className={className}>
      <SearchedProduct
        enableDeeplink
        item={item}
        index={index}
        className={twMerge('h-full', gtmClassName)}
        informationClassName="pb-3"
        callbackImpression={callbackImpression}
        onClickLikeButton={onClickLikeButton}
        callbackClick={callbackClickProduct}
        {...gtmDataAttrs}
      >
        <div className="px-3">
          <LinkGenerationBottomSheet
            item={item}
            productIndex={index ?? 0}
            onClickGenerateLink={callbackClickGenerateLink}
          >
            <Button
              variant="outlined"
              size="small"
              className="w-full bg-white"
              style={{
                padding: '3px 6px',
              }}
            >
              <Typography variant="body13pxMed">링크 생성</Typography>
            </Button>
          </LinkGenerationBottomSheet>
        </div>
      </SearchedProduct>
    </div>
  );
};

export const ProductSearchItem = memo(ProductSearchItemComponent);
